import { useEffect, useState } from 'react';

import { processValues } from '../Utils/processValues';
import { TPartials } from '../useGetProcessedValues.hook';

export type TUseProcessedValue = (
  stablefords: string[],
  start: number,
  end: number,
  partials: TPartials
) => string[];

export const useProcessedValue: TUseProcessedValue = (pars, start, end, partials) => {
  const [processedValue, setProcessedValue] = useState<string[]>([]);

  useEffect(() => {
    const newProcessedValue = processValues(pars, start, end, partials);

    setProcessedValue(newProcessedValue);
  }, [pars, start, end, partials]);

  return processedValue;
};
